var version = 1;
module.exports = function incrementVersion() {
    return version++;
};
